// extracted by mini-css-extract-plugin
export default {"cls1":"WBkvpVO0u1YAudXBlHiP","cls2":"dwg5zZudlNZtJdhUAi7I WBkvpVO0u1YAudXBlHiP","isAvatar":"AbFhXnqW7PEO_lLHoXjo"};